import * as React from 'react'
import FacetedCarousel from './FacetedCarousel/FacetedCarousel'
import SuperHero from './SuperHero/SuperHero'
import AdsCarousel from './AdsCarousel/AdsCarousel'
import BlueBar from './BlueBar'
import * as styles from './Collection.module.scss'
import * as cn from 'classnames'
import InView from 'react-intersection-observer'
import { StorefrontStateCollection, FeatureSwitches, StorefrontStateItem } from '../../containers/Storefront';
import { safeBool } from '@utils'

export interface CollectionProps extends StorefrontStateCollection {
  isPhablet: boolean
  collectionKey: number
  showBlueBars: boolean
  isLoading: boolean
  isFrozen: boolean
  fetch: Function
  hoverClass?: string
  featureSwitches: FeatureSwitches
  enrichCollection: Function
  enrichSingleItem: Function
  canLazyLoad?: boolean
  removeItem?: Function
  updateChannelItem?: Function
  canLivePlayback: boolean
  formFactor: string
  requestFocusForHover?: () => void
  resetFocusForHover?: () => void
  collectionHasFocusForHover?: boolean
  filterOn?: boolean
  isLast?: boolean
}

const carouselIsRemoved = (items: StorefrontStateItem[], filterOn: boolean) => {
  if (!filterOn)
    return false
  const hasRemainingItem = items.some((item) => {
    return safeBool(item.filterEntitled)
  })
  return !hasRemainingItem
}

const Collection = (props: CollectionProps) => {
  const { collectionType, items } = props

  switch (collectionType) {
    case 'SuperHero':
      return (
        <InView
          threshold={0.7}
        >
          {(inView) => 
            <SuperHero
              items={items.filter(item => item && item.image && item.link &&
              item.image.url && item.link.url && (!props.filterOn || item.filterEntitled))}
              webUid={props.webUid}
              modelDebug={props.modelDebug} 
              formFactor={props.formFactor}
              isFrozen={props.isFrozen || !inView}
            />
          }
        </InView>
      )
    case 'AdsCarousel':
      return (<AdsCarousel
        left={props.items[0]}
        right={props.items[1]}
      />)
    default:
      return (<FacetedCarousel
        {...props}
        isTwinHeroCarouselType={props.collectionType === 'TwinHero'}
        isSquareCarouselType={props.collectionType === 'SquareCarousel'}
        isPortraitCarouselType={props.collectionType === 'PortraitCarousel'}
        isDoubleDeckerCarouselType={props.collectionType === 'DoubleDeckerCarousel'}
        filterOn={props.filterOn && !carouselIsRemoved(props.items, props.filterOn)}
      />)
  }
}

const BlueBarWrapper = (props: CollectionProps) => props.showBlueBars && Boolean(props.collectionMeta) &&
  (<BlueBar {...props.collectionMeta} />)

const CollectionWrapper = (props: CollectionProps) => {
  const hasItems = props && props.items && props.items.length &&
    props.items.filter(i => !i.isRemoved).length
  if (!hasItems) {
    return (<BlueBarWrapper {...props} />)
  }
  const isRemoved = carouselIsRemoved(props.items, props.filterOn)
  return (
    <div className={cn(styles.Collection, 'u-collection tst-collection',
      {
        [styles.filterLoading]: props.isLoading &&
          props.collectionType !== 'SuperHero',
        [styles.containsSuperHero]: props.collectionType === 'SuperHero',
        [styles.isRemoved]: isRemoved
      },
      { ['mobile-collection']: props.isPhablet })}>
      <BlueBarWrapper {...props} />
      <Collection {...props} />
    </div>
  )
}

export default CollectionWrapper
